// extracted by mini-css-extract-plugin
module.exports = {"body":"OrdersTab_body__3Pix8","filter":"OrdersTab_filter__2reiD","grid":"OrdersTab_grid__2vE_l","footer":"OrdersTab_footer__D27og","dimmer":"OrdersTab_dimmer__1VjCi"};